import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ChevronRight24 = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M8 3.5625L16.04 11.6025C16.0922 11.6547 16.1337 11.7166 16.162 11.7848C16.1903 11.853 16.2048 11.9262 16.2048 12C16.2048 12.0738 16.1903 12.147 16.162 12.2152C16.1337 12.2834 16.0922 12.3453 16.04 12.3975L8 20.4375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
